// icons/health.svg

export const HealthIconV2 = (props) => (
  <svg
    className={props.className}
    width="29"
    height="26"
    viewBox="0 0 29 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.0262 3.64575C8.81786 3.64575 10.9679 4.72075 12.7595 6.51242L14.7304 8.48325L16.7012 6.51242C18.4929 4.72075 20.6429 3.64575 22.4345 3.64575C24.047 3.64575 25.4804 4.54158 26.0179 5.97491C26.9137 8.12491 26.0179 10.8124 23.5095 13.3207L14.7304 22.0999L5.9512 13.3207C3.44287 10.8124 2.54704 8.12491 3.44287 5.97491C3.98037 4.54158 5.4137 3.64575 7.0262 3.64575ZM22.2554 0.958252C19.9262 0.958252 17.2387 2.03325 14.5512 4.72075C11.8637 2.03325 9.1762 0.958252 6.84703 0.958252C0.755367 0.958252 -3.00713 8.48325 3.80121 15.2916L14.372 25.8624L24.9429 15.2916C32.1095 8.48325 28.5262 0.958252 22.2554 0.958252Z"
      fill="#34363E"
    />
  </svg>
);
